var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-row"},[_c('EstimatedNumberOfFramesField',_vm._g({attrs:{"field":"custom-dimension-3","placeholder":"Geschat aantal ramen"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }